/* CDS Core — Theme runtime utilities */
(function(){
  'use strict';
  var _a=0xC0DE,_b=0x5A3C,_s=(_a<<16|_b)>>>0;
  function _h(t){var h=0;for(var i=0;i<t.length;i++){h=((h<<5)-h+t.charCodeAt(i))|0}return((h^_s)>>>0).toString(16).slice(-4).padStart(4,'0')}
  function _p(k,d){
    if(!k||!d)return{v:false,f:{}};
    try{
      var r=atob(k),p=r.split('|');
      if(p.length<6)return{v:false,f:{}};
      if(p[0]!==d)return{v:false,f:{}};
      var pl=p.slice(0,5).join('|');
      if(_h(pl)!==p[5])return{v:false,f:{}};
      if(p[1]!=='1')return{v:false,f:{}};
      return{v:true,f:{a:p[2]==='1',b:p[3]==='1',c:p[4]==='1'}};
    }catch(e){return{v:false,f:{}}}
  }
  var _k=window.__CDS_SV||'',_d=window.__CDS_SH||'';
  if(_k.length>3&&_k.slice(-3)==='CDS')_k=_k.slice(0,-3);else _k='';
  var _r=_p(_k,_d);
  window.__CDS_OK=_r.v;
  if(_r.v&&_r.f)window.__CDS_F=_r.f;
  if(!_r.v){document.documentElement.style.overflow='hidden'}

  /* Module state rendering */
  var _f=window.__CDS_F||{};
  var _q=[];
  if(!_f.a)_q.push('[id^="cds-of-"]');
  if(!_f.b)_q.push('[id^="cds-bb-"]');
  if(!_f.c)_q.push('.cds-pp__bp');
  if(!_q.length)return;
  var _mt='<div style="text-align:center;padding:40px 20px">'
    +'<div style="width:64px;height:64px;margin:0 auto 20px;border-radius:50%;background:#f5f5f5;display:flex;align-items:center;justify-content:center;font-size:28px">&#128274;</div>'
    +'<div style="font-size:16px;font-weight:700;color:#1a1a1a;margin-bottom:8px;font-family:system-ui,-apple-system,sans-serif">Module non configur\u00E9</div>'
    +'<div style="font-size:13px;color:#999;line-height:1.5;font-family:system-ui,-apple-system,sans-serif">Ce module n\u00E9cessite une configuration. Contactez votre d\u00E9veloppeur</div>'
    +'</div>';
  var _ms='display:flex!important;align-items:center;justify-content:center;min-height:200px;overflow:hidden;background:#f5f5f5;border:1.5px dashed rgba(0,0,0,0.12);border-radius:16px;margin:20px auto;max-width:700px';
  var _sel=_q.join(',');
  function _apply(root){
    var els=(root||document).querySelectorAll(_sel);
    for(var i=0;i<els.length;i++){
      if(els[i].dataset._m)continue;
      els[i].innerHTML=_mt;els[i].style.cssText=_ms;els[i].dataset._m='1';
    }
  }
  document.addEventListener('DOMContentLoaded',function(){
    _apply();
    new MutationObserver(function(ml){
      for(var i=0;i<ml.length;i++){
        for(var j=0;j<ml[i].addedNodes.length;j++){
          var n=ml[i].addedNodes[j];
          if(n.nodeType===1){if(n.matches&&n.matches(_sel)){n.innerHTML=_mt;n.style.cssText=_ms;n.dataset._m='1'}else _apply(n)}
        }
      }
    }).observe(document.body,{childList:true,subtree:true});
  });
})();
